import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { APP_ROUTES } from '../../../shared/constants';
import { colors } from '@bafkal/ui-shared/tokens';
import AdList from './AdList';
import PlacementList from './PlacementList';

const InventoryPage = () => {
  const location = useLocation();
  const isPlacementsTab = location.pathname.startsWith(APP_ROUTES.INVENTORY.PLACEMENTS);
  const isAdUnitsTab = !isPlacementsTab;

  const createHref = isPlacementsTab
    ? APP_ROUTES.INVENTORY.PLACEMENT_NEW
    : APP_ROUTES.INVENTORY.NEW;
  const createLabel = isPlacementsTab ? 'New Placement' : 'New Ad Unit';

  const tabStyle = (active) => ({
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 4px 12px',
    borderBottom: active ? `2px solid ${colors.primary[600]}` : '2px solid transparent',
    fontSize: '0.875rem',
    fontWeight: active ? 600 : 400,
    color: active ? colors.neutral[900] : colors.neutral[500],
    textDecoration: 'none',
    transition: 'color 0.15s ease-in-out, border-color 0.15s ease-in-out',
  });

  return (
    <div className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '24px', borderBottom: `1px solid ${colors.neutral[200]}` }}>
          <div style={{ display: 'flex', gap: '24px' }}>
            <Link to={APP_ROUTES.INVENTORY.ROOT} style={tabStyle(isAdUnitsTab)}>
              Ad Units
            </Link>
            <Link to={APP_ROUTES.INVENTORY.PLACEMENTS} style={tabStyle(isPlacementsTab)}>
              Placements
            </Link>
          </div>
          <div style={{ paddingBottom: '12px' }}>
            <Link 
              to={createHref} 
              className="bafkal-btn bafkal-btn-primary" 
              style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: '6px', padding: '8px 16px', fontSize: '1rem', fontWeight: 500, textDecoration: 'none' }}
            >
              {createLabel}
            </Link>
          </div>
        </div>

        {isPlacementsTab ? <PlacementList /> : <AdList />}
      </div>
    </div>
  );
};

export default InventoryPage;
